import { useContext } from "react";
import config from "../../config";
import { useQuery } from "@tanstack/react-query";
import { AppContext } from "@/App.context";

// {
//     "tags": {
//     "id": string,
//     "name": string
//     }[]
//     }

/**
 * @typedef GetAllStatistics
 * @property {getTagsValue} tags
 */

/**
 * @typedef getTagsValue
 * @property {string} id
 * @property {string} name
 */

/**
 * @typedef GetAllStatisticsRes
 * @property {GetAllStatistics} data
 */

/**
 * @typedef GetAllStatisticsReq
 * @property {'aws' | 'gcp' | 'azure' | 'allclouds' } service
 * @property {string} fromDate
 * @property {string} toDate
 * @property {string} type
 * @property {string} name
 * @property {string} accounts
 * @property {string} regions
 * @property {string} spendingBy
 */

export const getSearchResultTags = (token) => {
  /**
   * @param {GetAllStatisticsReq} req
   * @param {AbortSignal=} signal
   * @returns {Promise<GetAllStatisticsRes>}
   */
  return async (
    { service, fromDate, toDate, accounts, regions, type, name, spendingBy },
    signal
  ) => {
    const body = {
      accounts: accounts || [],
      regions: regions || [],
      fromDate: fromDate,
      toDate: toDate,
      type: type,
      name: name,
      spendingBy:spendingBy
    };
    const statistics = await fetch(
      `${config.apiHost}/v1/${service}/search/search-result/tags`,
      {
        method: "POST",
        body: JSON.stringify(body),
        signal,
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );
    if (!statistics.ok) {
      throw new Error((await statistics.json()).message);
    }
    const response = await statistics.json();
    return response;
  };
};

/**
 * @param {GetAllStatisticsReq} req
 * @param {any[]=} deps
 */
export const useSearchResultTags = (req, deps = []) => {
  const appContext = useContext(AppContext);
  const query = useQuery({
    queryKey: ["getTagsInfoSearch", req, ...deps],
    queryFn: ({ signal }) => getSearchResultTags(appContext.idToken)(req, signal),
  });
  return query;
};
